import { type Post, type Media } from '@/payload-types'

export function getAuthors(post: Post) {
  const authors = (post.populatedAuthors || [])
    .filter(
      (author) =>
        typeof author === 'object' &&
        typeof author.name === 'string' &&
        typeof author.avatar === 'object',
    )
    .map((a) => ({ ...a, id: String(a.id) })) as { id: string; name: string; avatar: Media }[]

  return authors
}
